export default {"src":"/_next/static/media/MummyHead.48bef3c3.svg","height":75,"width":62};